import axios from "../axios";

const api = {
  getEmissionsDataComparison(accessToken) {
    const config = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get("/dashboard/emissions-data-comparison", config).then(({ data }) => data);
  }
};

export default api;